import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { Button } from '@shared';

@Component({
  selector: 'lib-success-dialog',
  imports: [Button, MatDialogClose],
  templateUrl: './success-dialog.html',
  styleUrl: './success-dialog.css',
})
export class SuccessDialog {
  data = inject<{ title: string; message: string; action: string }>(
    MAT_DIALOG_DATA,
  );
}
